import React from "react";
import { useSelector } from "react-redux";
import Header from "../../components/Header";
import StoreStatsCards from "./components/StoreStatsCards";
import QuickActions from "./components/QuickActions";
import StoreStockChart from "./components/StoreStockChart";
import StoreActivityLog from "./components/StoreActivityLog";
import StoreInsights from "./components/StoreInsights";
// import { getStoreManagementStats } from "../../redux/StoreManagement/storeManagementActions";
import { hasPermission } from "../../utils/permissionChecker";
import { PRIVILEGES } from "../../utils/privileges";

const StoreManagement = () => {
  // const dispatch = useDispatch();
  // const { statsLoading } = useSelector((state) => state.storeManagement);

  // useEffect(() => {
  //   // Fetch store management statistics on component mount
  //   dispatch(getStoreManagementStats());
  // }, [dispatch]);
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      {/* Page Header */}
      <Header text="Store Management" />

      {/* Top Section - Stats Cards + Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
        {/* Stats Cards - Takes 3 columns */}
        <div className="md:col-span-2">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <StoreStatsCards />
          </div>

          <div className="mt-4">
            <StoreStockChart />
          </div>
        </div>

        {/* Quick Actions - Takes 1 column */}
        <div>
          {hasPermission(user, PRIVILEGES.CREATE_STORE) && <QuickActions />}
          {/* Activity Log - Takes 1 column */}
          <div className="mt-4">
            <StoreActivityLog />
          </div>
        </div>
      </div>

      {/* Insights Section */}
      <StoreInsights />
    </>
  );
};

export default StoreManagement;
